import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Icon } from "~/components-shared";
import styled from "styled-components";
import { genericColorCombination } from "~/lib/resolvers";
const WrappedIcon = styled(Icon)`
  padding: ${_ref => {
  let {
    padding,
    theme
  } = _ref;
  return padding && padding * theme.spacing.step;
}}px;
  border-radius: 2em;
  background: ${_ref2 => {
  let {
    theme,
    color
  } = _ref2;
  return genericColorCombination(theme, color).background;
}};
  color: ${_ref3 => {
  let {
    theme,
    color
  } = _ref3;
  return genericColorCombination(theme, color).color;
}};
  border: 3px solid ${_ref4 => {
  let {
    theme,
    color
  } = _ref4;
  return genericColorCombination(theme, color).background;
}};
`;
const StyledIcon = _ref5 => {
  let {
    padding = 4,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(WrappedIcon, _extends({
    padding: padding,
    scale: 20,
    color: "translucentPrimary"
  }, rest));
};
export default StyledIcon;